import React from "react";
import "./ReturnOrderConfirmModal.css";

const ReturnOrderConfirmModal = ({ show, onClose, onContinue }) => {
  if (!show) return null;

  return (
    <div className="return-modal-backdrop">
      <div className="return-modal-box">
        <div className="return-modal-header">
          <span>Return</span>
          <button type="button" className="return-modal-close" onClick={onClose}>
            &times;
          </button>
        </div>

        <div className="return-modal-body">
          <p>
            Item return will be subject to merchant approvals with genuine reason.
            <br />
            Note: Perishable item and undergarment not returnable and other product
            must be return in original packaging as per return policy terms and
            condition applicable.
          </p>
        </div>

        <div className="return-modal-actions">
          <button type="button" className="return-modal-cancel" onClick={onClose}>
            Cancel
          </button>
          <button type="button" className="return-modal-continue" onClick={onContinue}>
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReturnOrderConfirmModal;
